<template>
    <v-toolbar
        :color="$vuetify.theme.headerBg"
        :height="60"
        class="app-header"
        fixed app clipped-left>
        <v-layout align-center justify-space-between row>
            <v-btn @click="toggleNavigation" color="fff" icon class="my-0 ml-0 mr-3">
                <v-icon color="white">menu</v-icon>
            </v-btn>
            <router-link :to="`/`">
                <Logo
                    color="#fff"
                    class="logo"
                    v-if="$utils.isNotMobile()"
                ></Logo>
            </router-link>
            <span class="app-name"
                  :style="{marginTop: $utils.isMobile() ? '0' : '22px', marginLeft: $utils.isMobile() ? '0' : '5px'}">{{ systemName }}</span>
            <v-spacer></v-spacer>
            <LanguageSelector></LanguageSelector>
            <UserMenu></UserMenu>
        </v-layout>
    </v-toolbar>
</template>
<script>
import UserMenu from '../modules/fptai/components/UserMenu.vue'
import Logo from '@/modules/fptai/components/Logo'
import LanguageSelector from '@/modules/fptai/components/LanguageSelector'
import AuthService from "@/services/auth.service";
import {actionTypes} from "@/store/actionTypes";
import {mapState} from "vuex";
import VueCookies from 'vue-cookies'
import moment from "moment";
import ProjectService from '@/services/project.service'

export default {
    name: 'AppToolbar',
    components: {
        LanguageSelector,
        Logo,
        UserMenu
    },
    created() {
        if (this.$store.getters.token) {
            this.$store.dispatch(this.$actionTypes.user.GET_PROFILE)
        }
    },
    data() {
        return {
            systemName: process.env.VUE_APP_PRODUCT_NAME,
            intervalGetAccessToken: null,
            timeIntervalGetToken: 60000 * 4,
        }
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile,
            accessToken: state => state.user.token,
        }),
    },
    mounted() {
        this.initAuth()
    },
    destroyed () {
        this.stopInterval()
    },
    methods: {
        toggleNavigation() {
            this.$store.dispatch(this.$actionTypes.TOGGLE_NAVIGATION)
        },
        checkExpiredToken () {
            let today = moment()
            return today.isBefore(moment(AuthService.decodeJWT(this.accessToken).exp * 1000))
        },
        initAuth () {
            // Update 2026-01-12: Clean up - the cookies below are no longer used
            VueCookies.remove('jwToken')
            VueCookies.remove('refreshToken')
            // check expired for access token
            if (this.checkExpiredToken()) {
                let currentTime = moment()
                let expiredTime = moment(AuthService.decodeJWT(this.accessToken).exp * 1000)
                let duration = moment.duration(expiredTime.diff(currentTime))
                let timeFirstWaiting = duration.asMilliseconds() > 30000 ? duration.asMilliseconds() - 30000 : 0

                this.getVersionPlatform()
                // first call get token again after: expiredTime - currentTime - 30(s)
                setTimeout(() => {
                    this.setIntervalGetToken(true)
                }, timeFirstWaiting)
                return
            }

            this.setIntervalGetToken()
        },
        setIntervalGetToken (isGetFirst = false) {
            if (isGetFirst) {
                this.getVersionPlatform()
                this.getToken()
            }

            this.intervalGetAccessToken = setInterval(() => {
                this.getToken()
            }, this.timeIntervalGetToken)
        },
        getToken() {
            AuthService.getNewAccessToken().then(result => {
                this.$store.commit(actionTypes.user.TOKEN, result.data.access)
                if (result.data.refresh) {
                    this.$store.commit(actionTypes.user.REFRESH_TOKEN, result.data.refresh)
                }
                AuthService.broadcastTokenUpdate()
            }).catch(err => {
                // 401 or 400 from refresh endpoint = permanent failure — stop retry
                // 401: token blacklisted/invalid (axios interceptor will redirect)
                // 400: missing/malformed token (retry is pointless)
                if (err && err.response && [400, 401].includes(err.response.status)) {
                    this.stopInterval()
                    return
                }
                // Other errors (network, 500, no refresh token) — do NOT stop, retry next cycle
                console.warn('Token refresh failed, will retry:', err && err.message)
            })
        },
        stopInterval () {
            clearInterval(this.intervalGetAccessToken)
            this.intervalGetAccessToken = null
        },
        getVersionPlatform() {
            if (!this.platformVersion) {
                ProjectService.getVersionPlatform().then(result => {
                    this.$store.commit(actionTypes.VERSION, result.data.version)
                })
            }
        },
    }
}
</script>
<style scoped lang="scss">
.app-name {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
}

.logo {
    width: 100px;
    height: 40px;
}
</style>
